import { gql } from '@apollo/client';

import { threadFragment } from '../fragments';

export default gql`
  mutation UpvoteThread($courseId: String!, $threadId: String!) {
    upvoteThread(courseId: $courseId, threadId: $threadId, input: {})
      @rest(
        type: "Thread"
        path: "/courses/{args.courseId}/threads/{args.threadId}/upvote"
        method: "PUT"
      ) {
      ...Thread
    }
  }
  ${threadFragment}
`;
